module.exports = __webpack_public_path__ + "static/media/news.aba66ed0.svg";